import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from "rxjs";
import {AccountSetting, CommonTransformationService} from '@app/shared';


@Injectable()
export class OrgAccountSettingService {

  constructor(private http: HttpClient, private commonTransService: CommonTransformationService) {
  }

  getDefaultOrgAccountSetting(txn: string, txnId: number): Observable<AccountSetting[]> {
    const url = `/account-settings/account-settings-for-transaction?refId=${txnId}&transaction=${txn}`;
    return this.http.get<AccountSetting[]>(url);

  }


  saveAccountSetting(accountSetting): Observable<any> {
    const url = '/account-settings/account-settings-for-tradingpartner';
    return this.http.post<any>(url, accountSetting);
  }

  updateAccountSetting(accountSetting: AccountSetting): Observable<any> {
    const url = `/account-settings/account-settings-for-tradingpartner/${accountSetting.id}`;
    return this.http.put<any>(url, accountSetting);
  }

}
